import type { PortalDashboardPageDefinition } from '@dlap-ui/shared-forms/shell/portal-shell/portal-shell';

export const DEEDS_DASHBOARD_PAGES: readonly PortalDashboardPageDefinition[] = [
  {
    path: 'reports',
    label: 'Dashboard',
    icon: 'dashboard',
    permission: 'reports',
    loadComponent: () => import('../reports/reports').then((m) => m.Reports),
  },
  {
    path: 'summary',
    label: 'Overview',
    icon: 'home',
    permission: 'overview',
    loadComponent: () => import('../overview/overview').then((m) => m.Overview),
  },
  {
    path: 'applications',
    label: 'Applications',
    icon: 'appstore',
    permission: 'applications',
    loadComponent: () =>
      import('../applications/applications').then((m) => m.Applications),
  },
  {
    path: 'applications/drafts',
    label: 'Drafts',
    icon: 'file-text',
    permission: 'applications/drafts',
    loadComponent: () => import('../applications/drafts/drafts').then((m) => m.Drafts),
  },
  {
    path: 'applications/archived',
    label: 'Archived',
    icon: 'inbox',
    permission: 'applications/archived',
    loadComponent: () => import('../applications/archived/archived').then((m) => m.Archived),
  },
  {
    path: 'services',
    label: 'Services',
    icon: 'unordered-list',
    permission: 'services',
    loadComponent: () => import('../services/services').then((m) => m.Services),
  },
  {
    path: 'wallet',
    label: 'Wallet',
    icon: 'wallet',
    permission: 'wallet',
    loadComponent: () => import('../wallet/wallet').then((m) => m.Wallet),
  },
  {
    path: 'tickets',
    label: 'Tickets',
    icon: 'inbox',
    permission: 'tickets',
    loadComponent: () =>
      import('@dlap-ui/shared-forms/tickets/tickets-page/tickets-page').then((m) => m.TicketsPage),
  },
  {
    path: 'tickets/system',
    label: 'System tickets',
    icon: 'inbox',
    permission: 'tickets/system',
    loadComponent: () => import('../system-tickets/system-tickets').then((m) => m.SystemTickets),
  },
  {
    path: 'plots',
    label: 'Properties',
    icon: 'file-text',

    permission: 'plots',
    loadComponent: () => import('../properties/properties').then((m) => m.Properties),
  },
  {
    path: 'farms',
    label: 'Farms',
    icon: 'gold',

    permission: 'farms',
    loadComponent: () => import('../farms/farms').then((m) => m.Farms),
  },
  {
    path: 'plot-staging',
    label: 'Properties',
    icon: 'file-sync',
    permission: 'plot-staging',
    loadComponent: () => import('../plot-staging/plot-staging').then((m) => m.PlotStaging),
  },
  {
    path: 'farm-staging',
    label: 'Farms',
    icon: 'file-sync',
    permission: 'farm-staging',
    loadComponent: () => import('../farm-staging/farm-staging').then((m) => m.FarmStaging),
  },
  {
    path: 'law-firms',
    label: 'Law Firms',
    icon: 'file-protect',
    permission: 'law-firms',
    loadComponent: () => import('../law-firms/law-firms').then((m) => m.LawFirms),
  },
  {
    path: 'individuals-biometrics',
    label: 'Individuals Biometrics',
    icon: 'idcard',
    permission: 'individuals-biometrics',
    loadComponent: () =>
      import('../individuals-biometrics/individuals-biometrics').then((m) => m.IndividualsBiometrics),
  },
  {
    path: 'auto-activation',
    label: 'Auto Activation',
    icon: 'thunderbolt',
    permission: 'auto-activation',
    loadComponent: () => import('../auto-activation/auto-activation').then((m) => m.AutoActivation),
  },
  {
    label: 'System Parameters',
    icon: 'setting',
    children: [
      {
        path: 'provinces',
        label: 'Provinces',
        icon: 'environment',
        permission: 'provinces',
        loadComponent: () => import('../system-parameters/provinces/provinces').then((m) => m.Provinces),
      },
      {
        path: 'offices',
        label: 'Offices',
        icon: 'bank',
        permission: 'offices',
        loadComponent: () => import('../system-parameters/offices/offices').then((m) => m.Offices),
      },
      {
        path: 'fees',
        label: 'Fees',
        icon: 'dollar',
        permission: 'fees',
        loadComponent: () => import('../system-parameters/fees/fees').then((m) => m.Fees),
      },
      {
        path: 'currencies',
        label: 'Currencies',
        icon: 'gold',
        permission: 'currencies',
        loadComponent: () => import('../system-parameters/currencies/currencies').then((m) => m.Currencies),
      },
    ],
  },
  {
    path: 'devices',
    label: 'POS Devices',
    icon: 'appstore',
    permission: 'devices',
    loadComponent: () => import('../devices/devices').then((m) => m.Devices),
  },
  {
    path: 'memberships/members',
    label: 'Members',
    icon: 'team',
    permission: 'memberships/members',
    loadComponent: () => import('../members/members').then((m) => m.Members),
  },
  {
    label: 'File Recovery',
    icon: 'file-text',
    children: [
      {
        path: 'file-recovery',
        label: 'Upload Files',
        icon: 'upload',
        permission: 'file-recovery',
        loadComponent: () =>
          import('../file-recovery-upload/file-recovery-upload').then((m) => m.FileRecoveryUpload),
      },
      {
        path: 'file-recovery/pending-applications',
        label: 'Pending Applications',
        icon: 'file-text',
        permission: 'file-recovery/pending-applications',
        loadComponent: () =>
          import('../pending-file-applications/pending-file-applications').then((m) => m.PendingFileApplications),
      },
      {
        path: 'file-recovery/jobs',
        label: 'Jobs',
        icon: 'history',
        permission: 'file-recovery/jobs',
        loadComponent: () => import('../file-recovery-jobs/file-recovery-jobs').then((m) => m.FileRecoveryJobs),
      },
    ],
  },
  {
    label: 'User Management',
    icon: 'team',
    children: [
      {
        path: 'roles-permissions',
        label: 'Roles and permissions',
        icon: 'key',
        permission: 'roles-permissions',
        loadComponent: () => import('../user-management/roles-permissions/roles-permissions').then((m) => m.RolesPermissions),
      },
      {
        path: 'users',
        label: 'Users',
        icon: 'team',
        permission: 'users',
        loadComponent: () => import('../user-management/users/users').then((m) => m.Users),
      },
    ],
  },
  {
    path: 'sanitization-audit',
    label: 'Sanitization Audit',
    icon: 'security-scan',
    permission: 'sanitization-audit',
    loadComponent: () =>
      import('../sanitization-audit/sanitization-audit').then((m) => m.SanitizationAudit),
  },
  {
    path: 'deeds/missing',
    label: 'Missing Deeds',
    icon: 'exclamation-circle',
    permission: 'deeds/missing',
    loadComponent: () => import('../missing-deeds/missing-deeds').then((m) => m.MissingDeeds),
  },
  {
    path: 'deeds/archived-plots',
    label: 'Archived Property',
    icon: 'inbox',
    permission: 'deeds/archived-plots',
    loadComponent: () => import('../archived-property/archived-property').then((m) => m.ArchivedProperty),
  },
  {
    path: 'deeds/archived-histories',
    label: 'Archived Histories',
    icon: 'history',
    permission: 'deeds/archived-histories',
    loadComponent: () => import('../archived-histories/archived-histories').then((m) => m.ArchivedHistories),
  },
  {
    path: 'profile',
    label: 'Profile',
    icon: 'idcard',
    permission: 'profile',
    showInMenu: false,
    loadComponent: () => import('@dlap-ui/shared-forms/profile/profile-page/profile-page').then((m) => m.ProfilePage),
  },
  {
    path: 'contact-messages',
    label: 'Contact Messages',
    icon: 'mail',
    permission: 'contact-messages',
    loadComponent: () =>
      import('@dlap-ui/shared-forms/landing-page/contact/contact-messages-page/contact-messages-page').then(
        (m) => m.ContactMessagesPage,
      ),
  },  {
    path: 'services/:type',
    label: 'Service Applications',
    icon: 'unordered-list',
    permission: 'services',
    showInMenu: false,
    loadComponent: () =>
      import('../services/service-applications/service-applications').then((m) => m.ServiceApplications),
  },

] as const;
